<template>
  <div class="dropdown compact-container">
    <button
      id="ddlCompactMenu"
      class="btn btn-dropdown-actions"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div class="btn-dropdown-items dropdown-toggle">
        <div class="btn-dropdown-icon tag-badge">
          <span class="dot">
            <em class="fas fa-user-edit orange-icon" />
          </span>
        </div>
        <span class="btn-dropdown-title">{{ selected.page.title }}</span>
      </div>
    </button>
    <div
      class="dropdown-menu dropdown-menu-custom"
      aria-labelledby="ddlCompactMenu"
    >
      <button
        v-for="(item, index) in items"
        :key="index"
        class="dropdown-item dropdown-item-custom"
        type="button"
        @click="onSelect(item)"
      >
        <div
          class="dropdown-menu-pages"
          :class="{ active: item.Id == selected.Id }"
        >
          <span>{{ item.page.title }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompactMenu',
  data() {
    return {
      selected: {
        page: {},
      },
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    tabId: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    onSelect(item) {
      this.selected = item;
      this.$emit('set-active-tab', this.selected);
    },
    getSelectedTab(tabId) {
      this.selected = this.items.find((x) => x.Id === tabId);
    },
  },
  mounted() {
    this.getSelectedTab(this.tabId);
  },
};
</script>

<style scoped>
.compact-container {
}
.btn-dropdown-actions {
  border-radius: 6px;
  border: 1px solid #3f5b60;
  min-height: 3rem;
  height: auto;
  background: #3f5b60;
  width: 100%;
}
/* align-items:center centra el ícono, el título y la flecha del dropdown
   (los tres son hijos flex de esta fila, ver .dropdown-toggle:after más
   abajo) verticalmente entre sí sin importar si el título ocupa una línea
   o se parte en varias -- antes cada uno se centraba a mano con
   margin-top/padding-top fijos calculados para una sola línea de texto y
   una altura fija de 3rem, así que un título largo (algunos tabs traen
   títulos bien largos, ej. "Participación de la familia y otras agencias y
   firmas") que se partía en 2+ líneas quedaba desalineado y además
   desbordaba la altura fija del botón. */
.btn-dropdown-items {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btn-dropdown-actions .btn-dropdown-icon {
  flex-shrink: 0;
}
.btn-dropdown-actions .btn-dropdown-items .btn-dropdown-title {
  color: #fff;
  font-size: 15px;
  line-height: 1.25;
  width: 100%;
  text-align: start;
}
.dropdown-menu-pages {
  padding: 20px 20px 20px 10px;
  background: #f2f2f2;
}
.dropdown-menu-pages.active {
  background: #ff7058;
}
.dropdown-menu-pages.active > span {
  color: #fff;
}
.dropdown-menu-custom {
  padding: 0px !important;
  transform: none !important;
  width: 100% !important;
  top: 48px !important;
}
.dropdown-item-custom {
  padding: 0px 0px 2px 0px;
}
.dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f077';
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  margin-right: 5px;
  border-top: none;
}
.btn-dropdown-actions[aria-expanded='true'] .dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f078';
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  border-top: none;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #fff !important;
  color: #3f5b60 !important;
}
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  border-radius: 26px;
  cursor: pointer;
}
/* Mismo fix de centrado por flexbox ya usado para la lupa de búsqueda: el
   padding-top fijo asumía una posición concreta del glifo del ícono dentro
   del círculo -- display:flex + align-items/justify-content:center lo
   centra de verdad sin importar el ícono. */
.dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
}
.orange-icon {
  color: #ff7058;
  font-size: 11pt;
}
.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

@media screen and (max-width: 768px) {
  .btn-dropdown-title {
    font-size: 15px !important;
  }

  .dropdown-toggle:after {
    font-size: 13px !important;
    margin-top: 5px !important;
    margin-right: -5px !important;
  }
  .dropdown-menu-pages {
    padding: 9px 18px 13px 2px !important;
  }
  .dropdown-menu-pages span {
    font-size: 15px !important;
  }
  .btn-dropdown-items.dropdown-toggle {
    margin-left: -15px !important;
    margin-top: -2px !important;
  }
}

@media screen and (max-width: 540px) {
  .btn-dropdown-title {
    font-size: 13px !important;
    overflow-wrap: break-word !important;
  }

  .dropdown-toggle:after {
    font-size: 13px !important;
    margin-top: 5px !important;
    margin-right: -5px !important;
  }

  .dropdown-menu-pages {
    padding: 9px 18px 13px 2px !important;
  }

  .dropdown-menu-pages span {
    font-size: 12px !important;
  }

  .btn-dropdown-items.dropdown-toggle {
    margin-left: -15px !important;
    margin-top: -2px !important;
  }
}
</style>
